import { useCallback, useEffect, useState } from 'react'
import Api from '../../Apis/api.service'
import { Box, makeStyles } from '@material-ui/core'

import { createTheme } from '@mui/material/styles'
import { useNotify } from 'react-admin'
import e from 'ringover-sdk'
import { getAllUsers, getEmailsHistory } from './api'
import { TabsHeader } from './components/TabsHeader'
import { SendEmailTab } from './components/SendEmailTab'
import { SentEmailsTab } from './components/SentEmailsTab'
import { useDebounce } from '../../hooks/useDebounce'

const theme = createTheme({
  components: {
    TableCell: {
      styleOverrides: {
        root: {
          padding: '0.5rem',
        },
      },
    },
  },
})
const useStyles = makeStyles((theme) => ({
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  tableHeader: {
    fontSize: '0.975em',
  },
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  contactPreferenceWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    margin: '1.1em 0 .6em 0',
    fontSize: '0.95em',
  },
  contactPreference: {
    color: '#143A5FF2',
    fontSize: '0.95em',
    marginTop: '.8em',
    border: '1px solid #5f6368ba',
    borderRadius: '50vh',
    padding: '0.3em 0.8em',
    width: 'fit-content',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#143A5FF2',
      color: 'white',
    },
  },
  sendingForm: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    margin: '.5em 1em',
  },
  tabs: {
    fontSize: '0.95em',
  },
}))

export const EMAIL_RECIPIENTS_TYPES = {
  DIRECT: 'direct',
  BCC: 'bcc',
}

export const MassMailList = () => {
  const notify = useNotify()
  const classes = useStyles()
  const [quillValue, setQuillValue] = useState('')

  const [copros, setCopros] = useState([])
  const [coprosLoading, setCoprosLoading] = useState(false)
  const [contacts, setcontacts] = useState([])
  const [coproValue, setCoproValue] = useState()
  const [selectAll, setSelectAll] = useState(false)
  const [selectAllCS, setSelectAllCS] = useState(false)
  const [subject, setSubject] = useState('')
  const [attachments, setAttachments] = useState([])
  const [tabValue, setTabValue] = useState(0)
  const [emails, setEmails] = useState({
    rows: [],
    count: 0,
    loading: false,
    rowsPerPage: 25,
    page: 0,
  })
  const [users, setUsers] = useState({
    rows: [],
    loading: false,
    selected: null,
  })
  const [recipientValue, setRecipientValue] = useState('')
  const [onlyCSMembersRecipients, setOnlyCSMembersRecipients] = useState(false)
  const [selected, setSelected] = useState([])
  const [recipientsType, setRecipientsType] = useState(
    EMAIL_RECIPIENTS_TYPES.BCC
  )

  const DEBOUNCE_DELAY = 1000
  const debouncedRecipientSearchValue = useDebounce(
    recipientValue,
    DEBOUNCE_DELAY
  )

  const _recipients = new Set([...selected])
  const recipients = Array.from(_recipients).join(', ')

  const editRecipients = (value) => {
    let recipients = value.split(',')
    recipients = recipients.map((item) => item.trim())
    setSelected(recipients)
  }

  let handleChangeQuill = (value) => {
    setQuillValue(value)
  }

  useEffect(() => {
    getCopros()
    setUsers({ ...users, loading: true })
    getAllUsers().then((res) => {
      setUsers({ ...users, rows: res, loading: false })
    })
  }, [])

  useEffect(() => {
    setEmails({ ...emails, loading: true })
    getEmailsHistory({
      senderId: users.selected?.id,
      mandat: onlyCSMembersRecipients ? 'CS Member' : '',
      recipientEmail: debouncedRecipientSearchValue,
      page: emails.page + 1,
      rowsPerPage: emails.rowsPerPage,
      coproId: coproValue?.db_id,
    }).then((res) => {
      setEmails({
        ...emails,
        rows: res.results,
        count: res.total,
        loading: false,
      })
    })
  }, [
    users.selected,
    emails.page,
    emails.rowsPerPage,
    onlyCSMembersRecipients,
    debouncedRecipientSearchValue,
    coproValue?.db_id,
  ])

  const getContacts = useCallback(async (coproId) => {
    coproId &&
      Api.copros
        .getContactsFromCopro(coproId)
        .then((response) => {
          const contactsWithEmail = response.data.filter(
            (contact) => contact.email
          )
          setcontacts(contactsWithEmail)
        })
        .catch((error) => {
          setcontacts([])
        })
  }, [])
  useEffect(() => {
    setSelected([])
    setSelectAll(false)
    setSelectAllCS(false)
    getContacts(coproValue?.db_id || [])
  }, [coproValue])

  const getCopros = () => {
    setCoprosLoading(true)
    Api.copros
      .getCopros()
      .then((response) => {
        setCopros(response.data)
        setCoprosLoading(false)
      })
      .catch((error) => {
        setCopros([])
        setCoprosLoading(false)
      })
  }
  const handleSelectAllChange = (event) => {
    setSelectAllCS(false)
    setSelectAll(event.target.checked)
    if (event.target.checked) {
      setSelected(
        contacts.map(function (item) {
          return item.email
        })
      )
    } else {
      setSelected([])
    }
  }
  const handleSelectAllCS = (event) => {
    setSelectAll(false)
    setSelected([])
    setSelectAllCS(event.target.checked)
    if (event.target.checked) {
      setSelected(
        contacts.reduce((acc, item) => {
          if (item.roles?.includes('CS Member')) {
            acc.push(item.email)
          }
          return acc
        }, [])
      )
    } else {
      setSelected([])
    }
  }

  const handleChange = (event) => {
    if (event === undefined) {
      return
    }
    if (typeof event === 'string') {
      event = { target: { value: event } }
    }
    const { value } = event.target
    if (selected.some((item) => item === value)) {
      _recipients.delete(value)
      setSelected(selected.filter((item) => item !== value))
    } else {
      _recipients.add(value)
      setSelected([...selected, value])
    }
  }

  const removeDuplicates = (arr) => {
    return arr
      .filter((item, index) => arr.indexOf(item) === index)
      .map((item) => {
        return item.trim()
      })
  }

  const handleChangeTabs = (event, newValue) => {
    setCoproValue(null)
    setTabValue(newValue)
  }

  const handleSend = (event) => {
    event.preventDefault()

    const recipients = removeDuplicates(selected)

    if (recipients.length === 0) {
      notify('Erreur: Aucun destinataire sélectionné', { type: 'error' })
      return
    }

    const wrongEmailAddresses = []

    recipients.forEach((recipient) => {
      if (!isEmailValid(recipient)) {
        wrongEmailAddresses.push(recipient)
      }
    })

    if (wrongEmailAddresses.length > 0) {
      notify(
        `Adresse(s) email invalide(s) : ${wrongEmailAddresses.join(', ')}`,
        { type: 'error' }
      )
      return
    }

    if (!subject.trim()) {
      notify("Erreur: Le sujet de l'email est vide", { type: 'error' })
      return
    }

    if (!quillValue.trim()) {
      notify("Erreur: Le corps de l'email est vide", { type: 'error' })
      return
    }

    if (!coproValue?.db_id) {
      notify('Erreur: Aucune copropriété sélectionnée', { type: 'error' })
      return
    }
    const message = {
      to: recipients,
      subject: subject,
      body: quillValue,
      coproId: coproValue.db_id,
      recipientsType,
      ...(attachments?.length > 0
        ? { attachmentsIds: attachments.map((attachment) => attachment.id) }
        : {}),
    }

    Api.massmails
      .postMail(message)
      .then(() => {
        notify(
          "L'email se prépare à être envoyé, vous pourrez consulter le statut de l’envoi dans quelques secondes dans l’onglet email envoyés",
          { type: 'success', multiLine: true }
        )
        resetForm()
      })
      .catch((error) => {
        notify(
          `Erreur lors de l'envoi de l'email : ${error.response.data.message}`,
          {
            type: 'error',
          }
        )
      })
  }

  const resetForm = () => {
    setCoproValue(null)
    setSelected([])
    setSubject('')
    setQuillValue('')
    setAttachments([])
    setSelectAll(false)
    setSelectAllCS(false)
  }

  const handleChangeEmailPage = (_, newPage) => {
    setEmails({ ...emails, page: newPage })
  }

  const handleChangeEmailRowsPerPage = (event) => {
    setEmails({
      ...emails,
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0,
    })
  }

  const isEmailValid = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

    return emailRegex.test(email)
  }

  return (
    <Box sx={{ width: '100%', marginTop: '1em' }}>
      <TabsHeader value={tabValue} onChange={handleChangeTabs} />
      {tabValue === 0 ? (
        <SendEmailTab
          tabValue={tabValue}
          tabIndex={0}
          copros={copros}
          coprosLoading={coprosLoading}
          coproValue={coproValue}
          setCoproValue={setCoproValue}
          selectAll={selectAll}
          handleSelectAllChange={handleSelectAllChange}
          selectAllCS={selectAllCS}
          handleSelectAllCS={handleSelectAllCS}
          classes={classes}
          contacts={contacts}
          setSelected={setSelected}
          setSelectAllCS={setSelectAllCS}
          setSelectAll={setSelectAll}
          handleChange={handleChange}
          theme={theme}
          selected={selected}
          recipients={recipients}
          editRecipients={editRecipients}
          subject={subject}
          setSubject={setSubject}
          quillValue={quillValue}
          handleChangeQuill={handleChangeQuill}
          attachments={attachments}
          setAttachments={setAttachments}
          handleSend={handleSend}
          recipientsType={recipientsType}
          setRecipientsType={setRecipientsType}
        />
      ) : (
        <SentEmailsTab
          copros={copros}
          coprosLoading={coprosLoading}
          coproValue={coproValue}
          setCoproValue={setCoproValue}
          tabValue={tabValue}
          tabIndex={1}
          users={users}
          setUsers={setUsers}
          emails={emails}
          classes={classes}
          theme={theme}
          handleChangeEmailPage={handleChangeEmailPage}
          handleChangeEmailRowsPerPage={handleChangeEmailRowsPerPage}
          onlyCSMembersRecipients={onlyCSMembersRecipients}
          setOnlyCSMembersRecipients={setOnlyCSMembersRecipients}
          recipientValue={recipientValue}
          setRecipientValue={setRecipientValue}
        />
      )}
    </Box>
  )
}
